import React, { useState } from 'react';

export const RequestAccess: React.FC = () => {
  const [patientName, setPatientName] = useState('');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md p-8 bg-white rounded-lg shadow text-center">
        <h2 className="text-2xl font-bold mb-4">Request Access</h2>
        <p className="text-gray-600 mb-6">You haven't been linked to a patient yet. Enter the patient's name to request access.</p>
        <div className="space-y-4">
          <input
            type="text"
            placeholder="Search by patient name"
            value={patientName}
            onChange={(e) => setPatientName(e.target.value)}
            className="w-full rounded border border-gray-300 px-3 py-2"
          />
          <button
            disabled={!patientName.trim()}
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            Request Access
          </button>
        </div>
      </div>
    </div>
  );
};